<header-title [model]="headerTitle"></header-title>



<div class="container-fluid mt-5">
    <div class="row">
        <div class="offset-lg-1 col-lg-10 col-md-12">

            <section class="panel">
                <div class="panel-body">
                    <div class="container-fluid">
                        <div class="row" style="border-bottom: 1px solid #adc6cd1a;">
                            <div class="col-md-6 mt-3 pl-4">
                                <h3>{{lender?.name}}</h3>
                            </div>
                            <div class="col-md-6 text-right">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mt-1 pl-4">
                                <h4>{{company?.tradingName || company?.legalName}}<span class="mx-3">:</span>Users</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="panel company-list mt-4">
                <div class="panel-body">
                    <div class="table-responsive" ng-nicescroll nice-option="{cursorcolor: '#e2edff'}">
                        <table class="table table-hover light mb-0">
                            <thead>
                                <tr>
                                    <th width="70%" class="px-4">Name</th>
                                    <th width="15%" class="px-4">Email</th>
                                    <th width="15%" class="text-center px-4">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let u of users;index as i">
                                    <td class="px-4">
                                        {{u.firstName}} {{u.lastName}}
                                    </td>
                                    <td class="px-4">{{u.email}}</td>
                                    <td class="actions text-center px-4">
                                        <a [routerLink]="['/lenders/user',company.id,u.id]" title="View"><i class="fas fa-eye"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </div>

    
</div>

